import { useMemo } from 'react'
import { useDocumentsLibrary } from '@/pages/Documents/useDocumentsLibrary'
import { rankRecentDocuments } from './rankRecentDocuments'
import { useRecentDocumentIds } from './useRecentDocumentIds'

/** The home Recent row: real documents from the library, recent-use first. */
export function useRecentDocuments() {
  const { items } = useDocumentsLibrary()
  const recentIds = useRecentDocumentIds()

  return useMemo(() => rankRecentDocuments(items, recentIds), [items, recentIds])
}
